import { Link } from "react-router-dom";
import clsx from "clsx";
import { KTSVG, toAbsoluteUrl } from "../../../helpers";
import { useLayout } from "../../core";
import { useStyleContext } from "../../../helpers/StyleContext";

const SidebarLogo = () => {
  const { config } = useLayout();
  const { styleState } = useStyleContext();

  const appSidebarDefaultMinimizeDesktopEnabled =
    config?.app?.sidebar?.default?.minimize?.desktop?.enabled;
  const appSidebarDefaultCollapseDesktopEnabled =
    config?.app?.sidebar?.default?.collapse?.desktop?.enabled;
  const toggleType = appSidebarDefaultCollapseDesktopEnabled
    ? "collapse"
    : appSidebarDefaultMinimizeDesktopEnabled
    ? "minimize"
    : "";
  const toggleState = appSidebarDefaultMinimizeDesktopEnabled ? "active" : "";
  const appSidebarDefaultMinimizeDefault =
    config.app?.sidebar?.default?.minimize?.desktop?.default;

  return (
    <div
      className="app-sidebar-logo px-3"
      id="kt_app_sidebar_logo"
      style={{
        ...(styleState?.sidebar_text_color && {
          borderBottom: `1px dashed ${styleState.sidebar_text_color}`,
        }),
      }}
    >
      <Link to="/dashboard">
        <img
          alt="Logo"
          src={toAbsoluteUrl("/media/logos/logo_white.png")}
          className="h-75px app-sidebar-logo-default"
        />
      </Link>

      <Link to="/dashboard">
        <img
          alt="Logo"
          src={toAbsoluteUrl("/media/logos/Logo_Branco_A.png")}
          className="h-70px app-sidebar-logo-minimize px-0"
        />
      </Link>

      {(appSidebarDefaultMinimizeDesktopEnabled ||
        appSidebarDefaultCollapseDesktopEnabled) && (
        <div
          id="kt_app_sidebar_toggle"
          className={clsx(
            "app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary body-bg h-30px w-30px position-absolute top-50 start-100 translate-middle rotate",
            { active: appSidebarDefaultMinimizeDefault }
          )}
          data-kt-toggle="true"
          data-kt-toggle-state={toggleState}
          data-kt-toggle-target="body"
          data-kt-toggle-name={`app-sidebar-${toggleType}`}
        >
          <KTSVG
            path="/media/icons/duotune/arrows/arr079.svg"
            className="svg-icon-2 rotate-180"
          />
        </div>
      )}
    </div>
  );
};

export { SidebarLogo };
